export const SOLSTICE = 'SOLSTICE';
export const FRAGRANCE_FREE = 'FRAGRANCE_FREE';
